import { useEffect, useState } from "react";

/**
 * Detects whether the current visitor is on a mobile device.
 * Combines a User-Agent test with a viewport-width check so we catch
 * tablets/phablets in portrait as "mobile" too.
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => detect(breakpoint));

  useEffect(() => {
    const onResize = () => setIsMobile(detect(breakpoint));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}

function detect(breakpoint) {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const narrow = window.innerWidth <= breakpoint;
  return uaMobile || narrow;
}
